export default "__VITE_ASSET__BTQ0fXJV__"